import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { TagsPage } from 'pages/settings/pages/tags'
import { TaggedContactsPage } from 'pages/settings/pages/tags/ui/TaggedContactsPage/TaggedContactsPage'

export const TagsRouter = observer(() => {
  return (
    <Routes>
      <Route index element={<TagsPage />} />
      <Route path={':id'} element={<TaggedContactsPage />} />
    </Routes>
  )
})
